import React, { useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  EmailIcon,
  FacebookMessengerIcon,
  TelegramIcon,
  ViberIcon,
  WhatsappIcon,
} from "react-share";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles
const convertDate = (date) => {
  const [year, month, day] = date.split("-");
  return [day, month, year].join("/");
};
function Umrlica({ post, modalIsOpen }) {
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  const [counter, setCounter] = useState(post.counter);
  const userRole = localStorage.getItem("userRole");

  const handleCandleClick = () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
    } else {
      setImageSrc(require("../assets/candle.png"));
    }
    increaseCounter();
  };

  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const increaseCounter = async () => {
    try {
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );

      setCounter(counter + 1);
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const modalStyle = {
    border: `5px solid ${
      post && post.color === "blue"
        ? "blue" // Use the specific color for "blue"
        : post.color === "green" ||
          post.color === "black" ||
          post.color === "red"
        ? post.color // Use other colors for "green," "black," or "red"
        : "black" // Default color for other cases
    }`,
    backgroundColor: "white",
    minHeight: "670px",
    padding: "0",
    border: `5px groove ${
      post && post.color !== null && post.color !== undefined
        ? post.color
        : "black"
    }`,
    width: "100%",
  };
  return (
    <Container
      data-aos="fade-up"
      className="post"
      id={modalIsOpen ? "umrlica-md-open" : "umrlica-md"}
      style={modalIsOpen ? { ...modalStyle, height: "auto" } : modalStyle}
      lg={6}
      sm={12}
      md={12}
    >
      <Row
        style={{
          fontStyle: "italic",
          border: "none",
          borderTop: "none",
          display: "flex",
          justifyContent: "end",
          paddingRight: "1.5rem",

          backgroundColor: "transparent",
          color: "gray",
          fontSize: "16px",
        }}
      >
        {post.type}
      </Row>
      <Col
        style={{ marginTop: "30px" }}
        className="d-flex justify-content-center"
      >
        <img
          id="umrlica-icon"
          style={{
            height: "60px",
            width: "60px",
            border: "none",
          }}
          src={post.icon}
          alt="x"
        />
      </Col>
      <Row style={{ paddingTop: "2%" }}>
        <Col className="d-flex justify-content-around"></Col>

        <Col className="d-flex justify-content-around">
          {post.images.length !== 0 && (
            <Carousel
              showThumbs={false}
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={2500}
            >
              {post.images
                .reduce((p, c) => p + c)
                .split(",")
                .map((imagePath, index) => (
                  <div className="d-flex justify-content-center" key={index}>
                    <div
                      style={{
                        width: "120px",
                        height: "150px",
                        border: "3px solid black",
                        background: `url(https://radojicictijanaa.pythonanywhere.com/${imagePath})`,
                        backgroundSize: "cover",
                        backgroundPosition: "50% 50%",
                      }}
                    ></div>
                  </div>
                ))}
            </Carousel>
          )}

          {post.images.length === 0 && (
            <div
              style={{
                width: "150px",
                height: "150px",
              }}
            ></div>
          )}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{ paddingTop: "3%" }}>
        <Col
          style={{
            fontWeight: "bold",
            letterSpacing: "1.2px",
            textAlign: "center",
          }}
          className="d-flex justify-content-around"
        >
          {post.name}
        </Col>
      </Row>
      <Col className="d-flex justify-content-around">
        <span style={{ fontSize: "small" }}>
          {" "}
          {convertDate(post.birth_date)} - {convertDate(post.death_date)}
        </span>
      </Col>
      <Row>
        <p
          className="main-text"
          style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "2%" }}
        >
          {post.main_text}
        </p>
      </Row>
      {modalIsOpen && (
        <Row>
          {" "}
          <span style={{ textAlign: "center" }}>Upali svijeću</span>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              borderRadius: "100%",
            }}
            onClick={handleCandleClick}
          >
            <img src={imageSrc} alt="alt text" />
          </button>
        </Row>
      )}
      {modalIsOpen && (
        <Row style={{ paddingBottom: "0" }}>
          {" "}
          <span style={{ textAlign: "center" }}>{counter}</span>
        </Row>
      )}
      <hr></hr>
      <Row>
        <h5
          className="bottom-text"
          style={{ paddingLeft: "5%", fontSize: "small" }}
          id="sakrij"
        >
          Ožalošćeni:
        </h5>
        <p
          className="bottom-text"
          style={{ paddingLeft: "5%", fontWeight: "bold" }}
          id="sakrij"
        >
          {post.text_bottom}
        </p>
      </Row>
      {!modalIsOpen && (
        <div className="predaj-pp-button">Predaj poslednji pozdrav</div>
      )}
      {modalIsOpen && (userRole === "admin" || userRole === "superadmin") && (
        <Col>
          <button className="btn btn-danger" onClick={() => deletePosts()}>
            Obriši
          </button>
        </Col>
      )}
      {modalIsOpen && (
        <div
          style={{ float: "right", paddingBottom: "2%", paddingRight: "1%" }}
        >
          <FacebookShareButton
            title="Facebook"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookShareButton>
          <span title="Viber">
            <ViberShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <ViberIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </ViberShareButton>
          </span>
          <EmailShareButton
            title="Email"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            subject="Check out this post"
          >
            <EmailIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </EmailShareButton>
          <FacebookMessengerShareButton
            title="Messenger"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookMessengerIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookMessengerShareButton>
          <span title="Telegram">
            <TelegramShareButton
              title="Telegram"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <TelegramIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </TelegramShareButton>
          </span>
          <span title="What's App">
            <WhatsappShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              title="Check out this post"
            >
              <WhatsappIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </WhatsappShareButton>
          </span>
        </div>
      )}
    </Container>
  );
}

export default Umrlica;
